import { Component, OnInit } from '@angular/core';
import { FiltersService } from "../../services/filters.service";
import { DisplayMessageToUserService } from "../../services/display-to-user-message.service";

@Component({
  selector: 'selected-filters-as-tags',
  templateUrl: './selected-filters-as-tags.component.html',
  styleUrls: ['./selected-filters-as-tags.component.sass']
})
export class SelectedFiltersAsTagsComponent implements OnInit {

  private filtersToRender: { [key: string]: boolean | null } = {};
  public filtersArrayToRender: any = []
  public tagsLabels: any;


  constructor(
    private filters: FiltersService,
    private displayMessage: DisplayMessageToUserService
  ) { }

  ngOnInit() {

    this.filters.getSubjectFiltersAfterChange().asObservable().subscribe( currentFilters => {
      
      
      if (currentFilters) { 
                
        this.filtersToRender = currentFilters;
        this.filtersArrayToRender = this.constructFiltersArrayFromObject(currentFilters)
      }
    })

    this.tagsLabels = this.displayMessage.getCurrentLang().tags
  }



  public deleteFilter(filterName: string) {
    this.filters.clearFilter(filterName)
    this.filtersArrayToRender = this.filtersArrayToRender.filter(current => {
      return current.name != filterName
    })
    delete this.filtersToRender[filterName]
  }

  private constructFiltersArrayFromObject(object: { [key: string]: boolean | null }) {
    let array = [];
    let propertiesArray = Object.keys(object);
    for (let i = 0; i < propertiesArray.length; ++i) {
      if( object[propertiesArray[i]] == true ){
        array.push({
          name: propertiesArray[i],
          value: object[propertiesArray[i]]
        })
      }
    }
    return array;
  }

  public getLabelByName(name: string): string {
    return this.tagsLabels[name];
  }

  public clearAllFilters(){
    this.filters.clearFilter('all');
    this.filtersArrayToRender = [];
  }


}
